/** A labelled form field: the label stays put when the user types, unlike a placeholder. */
export const Field = ({ label, required = false, hint, className = "", children }) => (
  <label className={`block ${className}`}>
    <span className="mb-2 flex items-baseline gap-2 text-[0.6rem] font-bold uppercase tracking-[0.16em] text-zinc-300">
      {label}
      {required ? <span className="text-maasai">required</span> : null}
    </span>
    {children}
    {hint ? <span className="mt-2 block text-[0.62rem] leading-relaxed text-zinc-400">{hint}</span> : null}
  </label>
);
